import { IoStatsChartOutline } from 'react-icons/io5';
import { getChartContainerStyles } from 'utils/charts/chartStyle.utils';

/** Show how the selected chart style applies to a sample temperature chart. */
const ChartPreview = ({ chartOptions }) => {
  const chartTheme = getChartContainerStyles(chartOptions);

  return (
    <div className="w-100">
      <p className="user-menu-subheading d-flex align-items-center gap-2">
        <IoStatsChartOutline aria-hidden="true" />
        Chart Preview
      </p>
      <div
        className={`accessibility-chart-preview overflow-hidden rounded-2 border ${
          chartTheme.className || ''
        }`}
        style={{ backgroundColor: chartTheme.panelBackground, color: chartTheme.textColor }}
      >
        <div className="small fw-semibold mb-2">Temperature Trend</div>
        <div
          className="accessibility-chart-plot position-relative rounded-2 h-75"
          style={{ backgroundColor: chartTheme.plotBackground }}
        >
          {[20, 45, 70].map((top) => (
            <div
              key={top}
              className="accessibility-chart-guide position-absolute start-0 end-0"
              style={{ top: `${top}%` }}
            />
          ))}
          <svg
            viewBox="0 0 260 80"
            className="position-absolute top-0 start-0 w-100 h-100"
            aria-hidden="true"
          >
            <polyline
              points="8,60 55,44 105,52 154,25 205,34 252,14"
              fill="none"
              stroke="#63a1e0"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <polyline
              points="8,69 55,57 105,62 154,43 205,47 252,31"
              fill="none"
              stroke="#f59e0b"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default ChartPreview;
